export default function buildCoupon(discounts) {
    if (!discounts) {
        return null
    }

    const codes = Object.values(discounts)
        .filter(discount => discount.type === 'coupon')
        .map(discount => discount.payload.options.code)

    return codes.length ? codes.join(', ') : null
}
